export enum SignalFuncId {
	POTENTIAL = 'POT',
	SWITCHBOARD = 'SWB',
	ARGONAUT = 'ARGO',
	POTENTIAL_V2 = 'POTV2',
	MOMENTUM = 'MOM',
	REGIME = 'REG',
	OASIS = 'OASIS',
	VOLATILITY = 'VOL',
	ONE = 'ONE',
	POTENTIAL_V3 = 'POTV3',
	SWITCHBOARD_V2 = 'SWBV2',
	OVERNIGHT_MR_ENTRY = 'OMRE',
	DEVELOPMENT = 'DEV',
	ARIMA = 'ARIMA',
	EXAMPLE = 'EXAMPLE',
	DOUBLE_CALENDAR_SPREAD = 'DCS'
}
